import { JobWithNotes, WorkNote } from '../workItemTypes';

export interface WorkNotesHandlers {
  handleAddComment: (job: JobWithNotes, comment: string) => void;
  handleAddAction: (job: JobWithNotes, action: string) => void;
  handleToggleActionCompletion: (job: JobWithNotes, noteId: string) => void;
}

interface UseWorkNotesProps {
  onJobUpdate?: (job: JobWithNotes) => void;
  currentUser?: string;
}

export const useWorkNotes = ({
  onJobUpdate,
  currentUser = 'Unknown User'
}: UseWorkNotesProps): WorkNotesHandlers => {

  const handleAddComment = (job: JobWithNotes, comment: string) => {
    if (!comment.trim()) return;

    const newNote: WorkNote = {
      id: `note_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      type: 'comment' as const,
      content: comment.trim(),
      author: currentUser,
      timestamp: new Date().toISOString(),
      isCompleted: false
    };

    const updatedJob: JobWithNotes = {
      ...job,
      notes: [...(job.notes || []), newNote]
    };

    onJobUpdate?.(updatedJob);
  };

  const handleAddAction = (job: JobWithNotes, action: string) => {
    if (!action.trim()) return;

    const newNote: WorkNote = {
      id: `note_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      type: 'action' as const,
      content: action.trim(),
      author: currentUser,
      timestamp: new Date().toISOString(),
      isCompleted: false
    };

    const updatedJob: JobWithNotes = {
      ...job,
      notes: [...(job.notes || []), newNote]
    };

    onJobUpdate?.(updatedJob);
  };

  const handleToggleActionCompletion = (job: JobWithNotes, noteId: string) => {
    const updatedNotes: WorkNote[] = (job.notes || []).map((note: WorkNote) => 
      note.id === noteId 
        ? { ...note, isCompleted: !note.isCompleted }
        : note
    );

    const updatedJob: JobWithNotes = {
      ...job,
      notes: updatedNotes
    };

    onJobUpdate?.(updatedJob);
  };

  return {
    handleAddComment,
    handleAddAction,
    handleToggleActionCompletion
  };
};